import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

function hexToRgb(h) {
  let r = 0
  let g = 0
  let b = 0

  if (h.length === 4) {
    r = '0x' + h[1] + h[1]
    g = '0x' + h[2] + h[2]
    b = '0x' + h[3] + h[3]
  } else if (h.length === 7) {
    r = '0x' + h[1] + h[2]
    g = '0x' + h[3] + h[4]
    b = '0x' + h[5] + h[6]
  }
  return `${+r}, ${+g}, ${+b}`
}

function generateRgbVar(name, color) {
  const colorRgb = hexToRgb(color)
  if (!colorRgb.includes('NaN')) {
    document.documentElement.style.setProperty(`--v-${name}-rgb`, colorRgb)
  }
}

export function createRgbVarsForThemes(themes) {
  Object.values(themes).forEach((theme) => {
    Object.entries(theme).forEach(([key, colors]) => {
      if (typeof colors === 'object') {
        Object.entries(colors).forEach(([colorKey, color]) => {
          generateRgbVar(`${key}-${colorKey}`, color)
        })
      } else {
        generateRgbVar(key, colors)
      }
    })
  })
}

export default new Vuetify({
  theme: {
    themes: {
      light: {
        neutral: {
          base: '#000000',
          lighten17: '#2B2B2B',
          lighten40: '#666666',
          lighten50: '#808080',
          lighten60: '#999999',
          lighten90: '#E6E6E6',
          lighten94: '#F0F0F0',
        },
        neutralLighten17: '#2b2b2b',
        neutralNeutral10: '#1A1A1A',
        neutralNeutral6: '#0F0F0F',
        neutralVariant20: '#322F37',
        neutralVariant40: '#605D66',
        neutralDark: '#2E3242',
        neutralMedium: '#545B78',
        surfaceLight: '#F9F9FB',
        outlineLight: '#E1E3EA',
        textBody1: '#5C6070',
        textBody2: '#73788C',
        primaryLightest: '#D3DBF8',
        surfaceMedium: '#F0F1F5',
        surface: {
          base: '#FCFCFC',
        },

        inverseSurface: {
          base: '#333333',
        },
        onSurface: {
          base: '#1D1B20',
        },
        onSurfaceVar: {
          base: '#49454F',
        },
        surfaceDim: {
          base: '#DEDEDE',
        },
        surfaceContainerHighest: {
          base: '#E6E6E6',
        },
        surfaceContainerHigh: {
          base: '#EBEBEB',
        },
        surfaceContainer: {
          base: '#F0F0F0',
        },
        inverseOnSurface: {
          base: '#F2F2F2',
        },
        surfaceContainerLow: {
          base: '#F5F5F5',
        },
        surfaceBright: {
          base: '#FCFCFC',
        },
        surfaceContainerLowest: {
          base: '#FFFFFF',
        },
        disabled: {
          base: '#B3B3B3',
        },
        outline: {
          base: '#78757A',
        },
        warning: {
          base: '#B2921D',
        },
        outlineVariant: {
          base: '#DBD8DE',
        },
        onPrimaryFixed: {
          base: '#003161',
        },
        outlineMedium: {
          base: '#C3C7D5',
        },
        outlineDark: {
          base: '#A5AAC0',
        },
      },
    },
    options: {
      customProperties: true,
      iconFont: 'mdi',
    },
  },
})
